import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useHistory, useLocation } from "react-router-dom";
import {
  FaBars,
  FaChevronDown,
  FaClipboardList,
  FaGlobeAfrica,
  FaHome,
  FaSearch,
  FaSignOutAlt,
  FaTimes,
  FaUser,
} from "react-icons/fa";
import { userSelector, clearState } from "../../User/UserSlice";
import { useTranslation } from "react-i18next";
import Logo from "../../assets/logounite2.png";
import "./auth-nav.css";

const languageLabels = {
  en: "English",
  fr: "Français",
};

const AuthNavBar = () => {
  const { t, i18n } = useTranslation();
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const { isError } = useSelector(userSelector);
  const [menuOpen, setMenuOpen] = useState(false);
  const [languageOpen, setLanguageOpen] = useState(false);
  const [accountOpen, setAccountOpen] = useState(false);
  const firstName = localStorage.getItem("firstNameFromServer") || "My";
  const lastName = localStorage.getItem("lastNameFromServer") || "Account";
  const trackingId = localStorage.getItem("trackingIDFromServer");
  const hasTrackingId = trackingId && trackingId !== "null";
  const applicationPath = hasTrackingId ? "/view-details" : "/biodata";
  const currentLanguage = languageLabels[i18n.language] || languageLabels.en;

  useEffect(() => {
    if (isError) {
      dispatch(clearState());
      history.push("/getstarted");
    }
  }, [isError, dispatch, history]);

  const closeMenus = () => {
    setMenuOpen(false);
    setLanguageOpen(false);
    setAccountOpen(false);
  };

  const changeLanguage = (language) => {
    i18n.changeLanguage(language);
    setLanguageOpen(false);
  };

  const onLogOut = () => {
    localStorage.clear();
    closeMenus();
    history.push("/getstarted");
  };

  const isActive = (path) => location.pathname === path;

  return (
    <header className="auth-nav">
      <div className="auth-nav-inner">
        <Link
          to="/"
          className="auth-nav-brand"
          onClick={closeMenus}
          aria-label="BioEnroll dashboard"
        >
          <img src={Logo} alt="BioEnroll" />
          <span>{t("citizen_workspace")}</span>
        </Link>
        <button
          type="button"
          className="auth-nav-menu-toggle"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-expanded={menuOpen}
          aria-label="Toggle navigation"
        >
          {menuOpen ? <FaTimes /> : <FaBars />}
        </button>

        <div className={`auth-nav-content ${menuOpen ? "open" : ""}`}>
          <nav className="auth-nav-links" aria-label="Authenticated navigation">
            <Link
              className={isActive("/") ? "active" : ""}
              to="/"
              onClick={closeMenus}
            >
              <FaHome /> {t("overview")}
            </Link>
            <Link
              className={isActive(applicationPath) ? "active" : ""}
              to={applicationPath}
              onClick={closeMenus}
            >
              <FaClipboardList />{" "}
              {hasTrackingId ? t("my_application") : t("start_enrollment")}
            </Link>
            <Link
              className={isActive("/track-enrolment") ? "active" : ""}
              to="/track-enrolment"
              onClick={closeMenus}
            >
              <FaSearch /> {t("track_status_menu")}
            </Link>
          </nav>

          <div className="auth-nav-utilities">
            <div
              className={`auth-nav-tracking ${hasTrackingId ? "issued" : ""}`}
            >
              <span>{t("tracking_id")}</span>
              <strong>{hasTrackingId ? trackingId : t("pending")}</strong>
            </div>
            <div className="auth-nav-dropdown">
              <button
                type="button"
                className="auth-nav-utility-button"
                onClick={() => {
                  setLanguageOpen(!languageOpen);
                  setAccountOpen(false);
                }}
                aria-expanded={languageOpen}
              >
                <FaGlobeAfrica /> <span>{currentLanguage}</span>{" "}
                <FaChevronDown />
              </button>
              {languageOpen && (
                <div className="auth-nav-menu">
                  {Object.entries(languageLabels).map(([language, label]) => (
                    <button
                      type="button"
                      key={language}
                      className={i18n.language === language ? "selected" : ""}
                      onClick={() => changeLanguage(language)}
                    >
                      {label}
                    </button>
                  ))}
                </div>
              )}
            </div>
            <div className="auth-nav-dropdown">
              <button
                type="button"
                className="auth-nav-account-button"
                onClick={() => {
                  setAccountOpen(!accountOpen);
                  setLanguageOpen(false);
                }}
                aria-expanded={accountOpen}
              >
                <span className="auth-nav-avatar">
                  <FaUser />
                </span>
                <span>
                  {firstName} {lastName}
                </span>
                <FaChevronDown />
              </button>
              {accountOpen && (
                <div className="auth-nav-menu account-menu">
                  <span className="account-menu-name">
                    {firstName} {lastName}
                  </span>
                  <button type="button" onClick={onLogOut}>
                    <FaSignOutAlt /> {t("sign_out")}
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default AuthNavBar;
